<template>
	<div v-show="isModalVisible">
	  <div class="modal-mask" @click="closeModal">
  		<div class="modal-container" @click.stop>
      		<!-- Modal Header -->
      		<div class="modal-header">
        	<h6 class="modal-title"><b>Assessment Details</b></h6>
        	<button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
      		</div>
      		<!-- Modal body -->
      		<div class="modal-body" >
                <div class="row col-12 p-0">
                  <div class="col-5 p-0 float- left">
                   <div class="title_text">First Name: <span style="font-weight: normal;">{{ menteeFirstName }}</span></div>
                   <div class="title_text">Last Name: <span style="font-weight: normal;">{{ menteeLastName }}</span></div>
                   <div class="title_text">Email: <span style="font-weight: normal;">{{ menteeEmail }}</span></div>
                  </div>
                  <div class="col-5 p-0 float- left">

                   <div class="title_text">Assessment Name: <span style="font-weight: normal;">{{ assessmentName }}</span></div>
                   <div class="title_text">Assigned Date: <span style="font-weight: normal;">{{ assignedDate | format1Date }}</span></div>
                  </div>
                  <div style="clear: both;"></div>
        		</div>

        		<div style="clear: both; margin-bottom: 20px;"></div>
        		<div class="col-6 border-class" style="margin: 0 auto;">
        		<div class="row account_view_list_heading_row col-12">
                   <div class="attempt_no_field heading" style="text-align: center;">Attempt No</div>
                   <div class="attempt_field heading" style="text-align: center;">Attempt Date</div>
                   <div class="score_field heading" style="text-align: center;">Score</div>
                   <div class="result_field heading" style="text-align: center;">View Report</div>
        		</div>

        		<div class="row account_view_list_row col-12" v-for="(item, index) in attempt_details" :key="index">
                   <div class="attempt_no_field text" style="text-align: center;">{{ parseInt(attempt_details.length - index) }}</div>
                   <div class="attempt_field text" style="text-align: center;">{{ item.Completed_date | format1Date }}</div>
                   <div class="score_field text" style="text-align: center;">{{ item.score }}</div>
                   <div class="result_field text view-certificate" @click="viewReport(item.id)" style="text-align: center;">View Results</div>
        		</div>
        		</div>

            </div>
            <div class="modal-footer" >
              <div class="col-12 text-center view-certificate" style="font-size: 13px;" @click="closeModal">
                <b>Close</b>
              </div>
            </div>
        </div>
      </div>

	</div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import router from '../../router/index.js';
import axios from 'axios';
import { store } from '../../store/store';
import moment from 'moment';

Vue.filter('format1Date', function(value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY')
  }
});

export default {
    props: [
    	'isModalVisible',
    	'assessmentId',
    	'menteeId',
    ],
    data: function () {
        return {
        	attempt_details: [],
        	menteeFirstName: '',
        	menteeLastName: '',
        	menteeEmail: '',
        	assessmentName: '',
        	assignedDate: '',
        }
    },        
    methods: {
    	viewReport: function(id) {
         let routeData = this.$router.resolve({name: 'assessmentreport', params: {assessmentAttemptId: id}});
          window.open(routeData.href, '_blank');
    	},
	    closeModal() {
	        this.menteeFirstName = '';
	        this.menteeLastName = '';
	        this.menteeEmail = '';
	        this.assessmentName = '';
	        this.assignedDate = '';
	        this.attempt_details = [];
	      this.$emit('close');
	    },

	    closeModal() {
	      this.$emit('close');
	    },
	    getUserAssessmentDetails: function(assessmentId, menteeId) {
	      axios.get('/desktop/get-user-assessment-details', {
	        params: {
	          mentee_id: menteeId,
	          accountId: this.$store.state.user_accountid,
	          assessment_id: assessmentId,
	        }
	      })
	      .then(response =>  {
	        this.menteeFirstName = response.data.mentee_first_name;
	        this.menteeLastName = response.data.mentee_last_name;
	        this.menteeEmail = response.data.mentee_email;
	        this.assessmentName = response.data.assessment_name;
	        this.assignedDate = response.data.assigned_date;
	        this.attempt_details = response.data.attempt_details;
	      })
	      .catch(() => {

	      });

	    },
    },
    components: {

    },
}
</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
}
.modal-container {
    width: 960px;
    height: 500px;
    overflow-y: scroll;
    margin: 40px auto 0;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    color: #002F42;
}
.modal-body {
    margin: 0px;
    padding: 10px;
}
@media(max-width:560px) {
  .modal-container {
    width: 98%;
    padding: 20px 20px;
  }
  .modal-body {
      margin: 0px;
      padding: 0px;
  }
}

.modal-header .sub-heading {
  background-color: #FFF;
  color: #555;
}
.modal-header {
  padding: 5px;
  border: 0px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.modal-footer {
  border-top: none;
}
.btn-info, .btn-info:hover, .btn-info:focus {
  background-color: #C3C3C3 !important;
  border: 1px solid #CCC !important;
  color: #000;
}
.btn {
  padding: 1px 0px;
}
.account_view_list_heading_row {
	background-color: #29A3E4;
	padding: 3px 10px;
}
.account_view_list_row { 
	width: 100%;
	padding: 5px 10px;
}
.heading {
	color: #FFF;
	font-size: 14px;
}
.title_text {
  font-size: 14px;
  font-weight: bold;
  width: 100%;
  margin-bottom: 10px;
  margin-left: 15px;
}
.text {
	color: #002F42;
	font-size: 13px;
	font-weight: bold;
}
.first_name_field, .last_name_field, .assigned_field {
	width: 18%;
	float: left;
}
.email_field {
	width: 21%;
	float: left;
}
.assessment_name_field {
	width: 25%;
	float:left;
}
.attempt_field, .result_field {
	width: 28%;
	float: left;
}
.attempt_no_field, .score_field {
  width: 22%;
  float: left;
}
.view-certificate {
    text-align: left;
    font-size: 11px;
    color: #29A3E4;
    cursor: pointer;
    text-decoration: underline !important;
	
}
.border-class .account_view_list_row:not(:last-child) {
  border-bottom: 1px solid #CCC;
}
</style>



// WEBPACK FOOTER //
// src/components/manager/UserAssessmentDetailsModal.vue